import mod from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DevIndicatore.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DevIndicatore.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./template/accueil/components/DevIndicatore.vue?vue&type=script&lang=js&
// module id = 470
// module chunks = 0